<template>
	<div class="content">
		<div class="content-assets">
			<div class="flex-cement">
				<img src="../../../assets/paynec/Group 1315@2x.png" style="width: 16px; height: 16px" />
				<div class="cement">提现记录</div>
			</div>
			<div class="border-top"></div>
			<div class="flex-right-paynces">
				<div class="flex-rightTap">
					<div class="flex-rightTap1" @click="flexClicl(1)">
						<div class="all-title" :class="{ 'all-title1': ids == 1 }">全部</div>
						<div class="border-top4" v-if="ids == 1"></div>
						<div class="border-top3" v-else></div>
					</div>
					<div class="flex-rightTap1" @click="flexClicl(2)">
						<div class="all-title" :class="{ 'all-title1': ids == 2 }">处理中</div>
						<div class="border-top4" v-if="ids == 2"></div>
						<div class="border-top3" v-else></div>
					</div>
					<div class="flex-rightTap1" @click="flexClicl(3)">
						<div class="all-title" :class="{ 'all-title1': ids == 3 }">已完成</div>
						<div class="border-top4" v-if="ids == 3"></div>
						<div class="border-top3" v-else></div>
					</div>
				</div>
				<!-- <div class="flex-date-filter">
					<div class="date-filter">日期筛选</div>
					<div>
						<el-date-picker
							style="width: 200px"
							v-model="dataTime"
							type="daterange"
							unlink-panels
							range-separator="-"
							start-placeholder="开始时间"
							end-placeholder="结束时间"
							:shortcuts="shortcuts"
							:size="size"
						/>
					</div>
					<div class="query-title">查询</div>
					<div style="margin-left: 10px">
						<el-select v-model="filter" placeholder="全部" size="default" style="width: 100px">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
						</el-select>
					</div>
				</div> -->
			</div>
			<div class="border-top" style="margin: 0; padding: 0"></div>
			<el-table :data="tableData" height="250" style="width: 100%; margin-top: 10px">
				<el-table-column prop="date" label="提现类型">
					<template #default="scope">{{ scope.row.type === 'normal' ? '交易额提现' : '分销佣金提现' }}</template>
				</el-table-column>
				<el-table-column prop="amount" label="提现账户">
					<template #default="scope">
						<div v-if="scope.row.payChannel === 'bank'">银行卡</div>
					  <div>{{ scope.row.payChannel === 'ali' ? '支付宝' : '微信' }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="amount" label="提现金额" />
				<el-table-column prop="serviceFee" label="手续费" />
				<el-table-column label="发起时间">
					<template #default="scope">{{ formatTime(scope.row.createTime) }}</template>
				</el-table-column>
				<el-table-column prop="address" label="完成时间">
					<template #default="scope">
						<span v-if="scope.row.payTime">{{ formatTime(scope.row.payTime) }}</span>
						<span v-else>--</span>
					</template>
				</el-table-column>
				<el-table-column prop="address" label="状态">
					<template #default="scope">
						<view v-if="scope.row.status === 0">待处理</view>
						<view v-if="scope.row.status === 10">已完成</view>
						<view v-if="scope.row.status === 20">提现失败</view>
					</template>
				</el-table-column>
			</el-table>

			<div style="display: flex; align-items: center; justify-content: space-between">
				<div class="pagination-contact">
					<el-pagination @current-change="handleCurrentChange" background layout="total, prev, pager, next,jumper" :total="total" />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted, onActivated } from 'vue';
import { cardPayPage } from '@/utils/api.js';
import dayjs from 'dayjs';

let ids = ref(1);
let dataTime = ref('');
let filter = ref('');
let pageNo = ref(1);
let tableData = ref([]);
let total = ref(0);
let options = ref([
	{ lable: '1', value: '全部' },
	{ lable: '2', value: '今天' },
	{ lable: '3', value: '最近7天' },
	{ lable: '4', value: '1个月' },
	{ lable: '5', value: '2个月' },
	{ lable: '6', value: '3个月' },
	{ lable: '7', value: '1年' }
]);
const info = async () => {
	let status = '';
	if (ids.value == 1) {
		status = '';
	} else if (ids.value == 2) {
		status = 0;
	} else {
		status = 10;
	}
	let res = await cardPayPage({
		pageNo: pageNo.value,
		pageSize: 10,
		status: status
	});
	console.log(res);
	tableData.value = res.data?.list;
	total.value = res.data?.total;
};
const formatTime = (item) => {
	let date = dayjs(item).format('YYYY-MM-DD HH:MM');
	return date;
};
const handleCurrentChange = (item) => {
	pageNo.value = item;
	info();
};
const flexClicl = (item) => {
	ids.value = item;
	info();
};
onMounted(() => {
	info();
});

onActivated(() => {
	info();
});
</script>

<style lang="scss" scoped>
.content-assets {
	padding: 20px 21px;
}

.content {
	width: 85%;
	background-color: #fff;
	margin-left: 20px;
	margin-left: auto;
}

.flex-cement {
	position: relative;
	display: flex;
	align-items: center;

	.cement {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 20px;
		color: #333333;
		margin-left: 8px;
		font-style: normal;
		text-transform: none;
	}
}

.flex-contact-slices {
	position: absolute;
	top: 0;
	right: 0;
	display: flex;
	align-items: center;
}

.assets-return {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	margin-left: 4px;
	margin-top: 2px;
}

.border-top {
	width: 99%;
	height: 0px;
	border-top: 1px solid #eeeeee;
	margin-top: 16px;
	padding-top: 16px;
}

.flex-const-slice {
	display: flex;
	margin-top: 10px;
}
.title-slice {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 18px;
	color: #333333;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-top: 2px;
}

.title-slice1 {
	color: #ff2f17;
}

.december {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 17px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-left: 5px;
	margin-top: -2px;
}

.flex-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.flex-more {
	display: flex;
	justify-content: space-between;
	margin-left: 44px;
	margin-top: 30px;
}
.more-text {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	text-align: center;
	font-style: normal;
	margin-top: 6px;
	text-transform: none;
}
.hot-group {
	white-space: nowrap;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 11px;
	color: #000000;
	font-style: normal;
	text-transform: none;
	padding-bottom: 7px;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: -10px;
}
.hot-group1 {
	margin-top: 80px;
}
.title-tots {
	white-space: nowrap;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 11px;
	color: #000000;
	font-style: normal;
	text-transform: none;
}
.hot-slices {
	margin: auto;
	width: 50px;
	height: 0px;
	border-top: 2px solid #eeeeee;
	padding-top: 10px;
}

.images {
	width: 85%;
	height: auto;
}

.assets-vector {
	width: 94%;
	background: #fff5f5;
	border-radius: 7px;
	margin: auto;
	margin-top: 70px;
}
.asset-paingd {
	padding: 16px 12px;
	display: flex;
	align-items: center;
}

.title-asset {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #db8a8a;
	font-style: normal;
	text-transform: none;
	margin-left: 8px;
}

.all-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #000000;
	font-style: normal;
	text-transform: none;
}

.border-top4 {
	width: 29px;
	height: 2px;
	background: #ec3925;
	border-radius: 0px 0px 0px 0px;
	margin-top: 13px;
}
.border-top3 {
	width: 29px;
	height: 2px;
	border-radius: 0px 0px 0px 0px;
	margin-top: 13px;
}

.flex-right-paynces {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.flex-rightTap {
	display: flex;
	align-items: center;
	margin-left: -34px;
}

.flex-rightTap1 {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-left: 54px;
}

.all-title1 {
	color: #ec3925;
}

.flex-date-filter {
	display: flex;
	align-content: center;
	align-items: center;
	margin-top: -16px;
}

.date-filter {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-right: 10px;
}

.query-title {
	width: 52px;
	height: 32px;
	background: #ff3333;
	border-radius: 4px 4px 4px 4px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #ffffff;
	line-height: 32px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-left: 11px;
}

.flex-rightTap1:hover {
	cursor: pointer;
}
</style>
